import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Button, Card, CardBody, CardHeader, Col, Collapse, Container, Input, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Row, Spinner, Table } from 'reactstrap';
import { Link } from 'react-router-dom';
import { ApplicationState } from '../../store';
import * as ARInvoiceStore from '../../store/ARInvoice';
import * as FullSteamStore from '../../store/CreditCardFS';
import * as ARInvoiceMdls from '../../models/ArInvoiceModel';
import * as SessionMdl from '../../models/SessionModel';
import { LoadingIcon } from '../Misc/Loading';
import { SaCurrency, SaDate, SaLabel } from '../Misc/SawinComponents';
import { useEffect, useState } from 'react';
import * as CreditCardMdls from '../../models/CreditCardModelFS';
import { SaCreditCardNumber } from '../Misc/SawinCreditCardNumber';
import ScriptTag from 'react-script-tag';

type MyProps =
    { ARInvoiceList: ARInvoiceMdls.ArInvoiceModelList, SessionState: SessionMdl.SessionModel, ChargeCCState: CreditCardMdls.CreditCardFSProcess } & typeof FullSteamStore.actionCreators;

const FullSteamPay: React.FunctionComponent<MyProps> = (props: MyProps) => {

    window.chargeFSCreditCard = (jsonResult: any) => {        
        var sendValue = { jsonStrResult: jsonResult, storeCard: SaveCCProp};
        props.chargeWithNewCreditCard(sendValue);
    };

    interface InvoiceLineProp { invoice: ARInvoiceMdls.ArInvoiceModel }

    const InvoiceLine: React.FunctionComponent<InvoiceLineProp> = (props: InvoiceLineProp) => {
        return (
            <Row>
                <Col>
                    <SaLabel Text={props.invoice.invoiceNumber} />
                    <SaCurrency Amount={props.invoice.balanceDue} />
                </Col>
            </Row>
        )
    }

    const [AmountBalance, updateBalanceDueState] = useState<number>(0);
    const [totalbalanceDue, updateTotalDueState] = useState<number>(0);
    const [programFeeAmt, updateProgramFee] = useState<number>(0);

    useEffect(() => {        
        props.retrieveAuthenticationKey(props.SessionState);
        props.retrieveStoredCards(props.SessionState);
        const AmountBalance = props.ARInvoiceList.items.reduce((mySum, x) => mySum + (x.isSelectedToPay ? x.total : 0), 0);
        updateTotalDueState(AmountBalance);
        const Fee = props.ARInvoiceList.items.reduce((mySum, x) => mySum + (x.isSelectedToPay ? x.programFee : 0), 0);
        updateProgramFee(Fee);
        updateBalanceDueState(AmountBalance + Fee);

    }, []);
        
    const fullsteamHostedPaymentsParameters = {
        "authenticationKey": props.ChargeCCState.authKey,// should get from server
        "operationType": "HostedPaymentsAccountId",
        "paymentSourceType": "Card",
        "cardEntryContext": "WebConsumerInitiated",
        "achAuthorizationType": "Web",
        "nameOnAccountField": "NameOnAccount",
        "zipField": "Zip",
        "showNameOnAccount": true,
        "showZip": true,
        "formId": "tokenForm",
        "submitText": "Charge",
        "completionCallback": window.fullsteamEnd
    };

    /*  const [StoredCreditCards, updateStoredCreditCards] = useState<CreditCardMdls.CreditCardModel[]>();*/
    //const SelectedCreditCardSequence = useState<number>(-1);

    const [SaveCCProp, updateSaveCCProp] = useState<boolean>(false);

    const checkBoxHandler = ( e: React.ChangeEvent<HTMLInputElement>) => {        
        updateSaveCCProp(e.target.checked);
    };
 
    const PayNowBtn = () => {

        if (props.ChargeCCState.prossesingStatus != CreditCardMdls.CreditCardProcessStatus.InProcesses) {
            return (<>
                <input type="submit" value="Pay with existing Card" className="btn btn-success" id="AuthorizeBtn" name="AuthorizeBtn" />
            </>);
        } else {
            return (<span>Loading<Spinner size="sm" color="primary" /></span>);
        }
    }

    const PayNewCardBtn = () => {

        if (props.ChargeCCState.prossesingStatus != CreditCardMdls.CreditCardProcessStatus.InProcesses) {
            return (<>
                <button type="button" className="btn btn-success" onClick={() => window.launchFullsteamHostedPayments(fullsteamHostedPaymentsParameters)}>Pay With New Card</button>                
            </>);
        } else {
            return (<span>Loading<Spinner size="sm" color="primary" /></span>);
        }
    }

    const PayInvoice = (args: { props: MyProps }) => {

        const PayInvoiceInitialState = (props: MyProps): CreditCardMdls.CreditCardModel => {
            return {
                ...CreditCardMdls.initialState,
                avsStreet: props.SessionState.SelectedAR.address.line1,
                avsZip: props.SessionState.SelectedAR.address.zip
            }
        }

        const [SelectedCreditCardSequence, updateCreditCardSequence] = useState<number>(-1);

        const SubmitEvent = (e: React.FormEvent) => {
            e.preventDefault();
            if (SelectedCreditCardSequence <= 0) {
                alert("Select a credit card to charge");
                return;
            }
            props.chargeCreditCard(SelectedCreditCardSequence);
            //if (CreditCardInfo.number && CreditCardInfo.number.length >= 15 && CreditCardInfo.number.length <= 16) {
            //    props.chargeCreditCard(CreditCardInfo);
            //} else {
            //    alert("Credit Card number is not valid");
            //}
        }

        const handleChangeCard = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
            e.preventDefault();
            var valueChanged = { [e.target.id]: e.target.value };
            updateCreditCardSequence(Number(e.target.value));
        }

        const handleChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>) => {
            e.preventDefault();
            //if (e.target.id == 'customer.email') {
            //    var valueChangedCust = { customer: { ...CreditCardInfo.customer, email: e.target.value } };
            //    updateCreditCard({ ...CreditCardInfo, ...valueChangedCust });
            //}
            //if (e.target.id == 'customer.name') {
            //    var valueChangedCust = { customer: { ...CreditCardInfo.customer, name: e.target.value } };
            //    updateCreditCard({ ...CreditCardInfo, ...valueChangedCust });
            //} else if (e.target.id == 'customer.email') {
            //    var valueChangedCust = { customer: { ...CreditCardInfo.customer, email: e.target.value } };
            //    updateCreditCard({ ...CreditCardInfo, ...valueChangedCust });
            //} else {
            //    var valueChanged = { [e.target.id]: e.target.value };
            //    updateCreditCard({ ...CreditCardInfo, ...valueChanged });
            //}
        }
        

        return (
            <>
                {props.ChargeCCState.hostedFormURL && <ScriptTag type="text/javascript" src={props.ChargeCCState.hostedFormURL + "/js/hostedforms/2.0.0/fullsteam.hostedforms.js"} />}
                <Card>
                    <CardHeader>
                        <h3> Pay Invoice</h3>
                        {/*{*/}
                        {/*    props.ARInvoiceList.items.map((item, index) => {*/}
                        {/*        if (item.isSelectedToPay) {*/}
                        {/*            return (<InvoiceLine invoice={item} key={index}></InvoiceLine>);*/}
                        {/*        }*/}
                        {/*    })*/}
                        {/*}*/}
                        <Row>
                            <Col className="right-align" style={{ marginTop: "10px" }}>
                                <SaLabel Text="Invoice Total" />
                                <SaCurrency Amount={totalbalanceDue} />
                            </Col>
                            {props.SessionState.TransactionFeeEnabled &&
                                <Col className="right-align" style={{ marginTop: "10px" }}>
                                    {props.SessionState.SelectedAR.creditCardEnabled &&
                                        <>
                                            <SaLabel Text={props.SessionState.TransactionFeeLabel} />
                                            <SaCurrency Amount={programFeeAmt} />
                                        </>
                                    }
                                </Col>
                            }
                            <Col className="right-align">
                                <SaLabel Text={'Payment Amount'} />
                                <SaCurrency Amount={AmountBalance} />
                            </Col>
                        </Row>                        
                    </CardHeader>
                    <CardBody>
                        <form onSubmit={SubmitEvent}>

                            {/*<SaLabel Text="Email For Receipt" />*/}
                            {/*<input type="text" onChange={handleChange} className="form-control" key="customer.email" id="customer.email" name="customer.email" value={CreditCardInfo.customer.email} />*/}
                            <div>
                                <SaLabel Text={"Credit Cards"} />
                                <Input type="select" id="CreditCardNumber" name="CreditCardNumber" onChange={handleChangeCard}>
                                    <option key="-1" value="-1"></option>)
                                    {props.ChargeCCState.storedCreditCards &&
                                        props.ChargeCCState.storedCreditCards.map((item, index) =>
                                            <option key={item.sequence} value={item.sequence}>{item.last4digits} {item.cardExpiryMonth}/{item.cardExpiryYear}</option>)
                                    }
                                </Input>
                            </div>
                            <div className="col-sm-12" style={{ textAlign: "right" }}>
                                <br />                               
                                <PayNowBtn />
                            </div>
                        </form>                       
                    </CardBody>
                </Card>

                <Card>
                    <CardBody>
                        <div className="col-sm-12 pl-3">
                            <Input type="checkbox" id="StoreCCChk" checked={SaveCCProp} onChange={(e) => checkBoxHandler(e)} />Save new credit card
                            
                        </div>
                        <div className="col-sm-12" style={{ textAlign: "right" }}>
                            
                            <PayNewCardBtn />
                        </div>
                        
                    </CardBody>
                </Card>
               
                  
            </>);
    }
    
    const PayInvoiceResult = () => {
        if (props.ChargeCCState.success) {
           
            return (<Card>
                <CardBody>
                    <p className='center-align'>
                        <img src={'./img/checkmark.gif'} />
                    </p>
                    <p className='center-align'>
                        Your Payment is Complete
                    </p>
                    <p className='center-align'>
                        <a href={props.ChargeCCState.receiptLink} target='_blank'>Get your receipt here</a>
                    </p>
                </CardBody>
            </Card>);
        } else {
            return (<Card>
                <CardBody>
                    <p className='center-align'>
                        <img src={'./img/cross.gif'} />
                    </p>
                    <p className='center-align'>
                        Your Payment was not processed.
                    </p>
                    <p className='center-align'>
                        {props.ChargeCCState.error}
                    </p>
                </CardBody>
            </Card>);
        }
    }

    return (
        <Container fluid={true}>           
            <LoadingIcon loading={props.ARInvoiceList.loading} title={props.SessionState.SelectedSM.id + " - " + props.SessionState.SelectedSM.name.displayName} address={props.SessionState.SelectedSM.address} />
            {                
                   (props.ChargeCCState.prossesingStatus != CreditCardMdls.CreditCardProcessStatus.Finished ? <PayInvoice props={props} /> : <PayInvoiceResult />)             
            }

        </Container>
    );

}
       
     


export default connect((state: ApplicationState) =>
({
    ...{
        ARInvoiceList: state.openInvoicesState,
        SessionState: state.sessionState,
        ChargeCCState: state.chargeCreditCardFSState
    }
}),
    FullSteamStore.actionCreators)(FullSteamPay as any);